"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatchConvAiSettingsRequest = void 0;
const core = __importStar(require("../../../../../../../core"));
const ConversationInitiationClientDataWebhook_1 = require("../../../../../../types/ConversationInitiationClientDataWebhook");
const ConvAiWebhooks_1 = require("../../../../../../types/ConvAiWebhooks");
exports.PatchConvAiSettingsRequest = core.serialization.object({
    conversationInitiationClientDataWebhook: core.serialization.property("conversation_initiation_client_data_webhook", ConversationInitiationClientDataWebhook_1.ConversationInitiationClientDataWebhook.optional()),
    webhooks: ConvAiWebhooks_1.ConvAiWebhooks.optional(),
    canUseMcpServers: core.serialization.property("can_use_mcp_servers", core.serialization.boolean().optional()),
    ragRetentionPeriodDays: core.serialization.property("rag_retention_period_days", core.serialization.number().optional()),
});
